module.exports = __webpack_public_path__ + "img/egg.5f748810.svg";